var map = {
	"./Admin.jsx": [
		"./src/pages/Admin.jsx",
		"vendors-node_modules_css-loader_dist_runtime_api_js-node_modules_css-loader_dist_runtime_sour-cc0fa5",
		"src_components_SvgIcon_jsx",
		"src_styles_main_scss",
		"src_components_Tooltip_jsx-src_utils_adminAuth_js-src_assets_flags_sync_svg_",
		"src_pages_Admin_jsx"
	],
	"./AdminAppInstalls.jsx": [
		"./src/pages/AdminAppInstalls.jsx",
		"vendors-node_modules_css-loader_dist_runtime_api_js-node_modules_css-loader_dist_runtime_sour-cc0fa5",
		"src_components_SvgIcon_jsx",
		"src_styles_main_scss",
		"src_components_Tooltip_jsx-src_utils_adminAuth_js-src_assets_flags_sync_svg_",
		"src_pages_AdminAppInstalls_jsx"
	],
	"./AppPresskit.jsx": [
		"./src/pages/AppPresskit.jsx",
		"src_components_SvgIcon_jsx",
		"src_components_Footer_jsx-src_components_Header_jsx-node_modules_css-loader_dist_runtime_api_-5603e7",
		"src_styles_todo_scss-src_assets_images_todoz001_png-src_assets_images_todoz002_png-src_assets-a6f61b",
		"src_styles_skyki_scss-src_assets_images_img001_png-src_assets_images_img002_png-src_assets_im-9848bf",
		"src_styles_qibla_scss-src_assets_images_qibla001_png-src_assets_images_qibla002_png-src_asset-641f16",
		"src_styles_timez_scss-src_assets_images_timez001_png-src_assets_images_timez002_png-src_asset-13183e",
		"src_components_Button_jsx",
		"src_pages_AppPresskit_jsx"
	],
	"./Apps.jsx": [
		"./src/pages/Apps.jsx",
		"src_components_SvgIcon_jsx",
		"src_styles_main_scss",
		"src_pages_Apps_jsx-node_modules_css-loader_dist_runtime_api_js-node_modules_css-loader_dist_r-2d1aba"
	],
	"./Appz.jsx": [
		"./src/pages/Appz.jsx",
		"vendors-node_modules_css-loader_dist_runtime_api_js-node_modules_css-loader_dist_runtime_sour-cc0fa5",
		"src_styles_main_scss",
		"src_pages_Appz_jsx"
	],
	"./Focus.jsx": [
		"./src/pages/Focus.jsx",
		"src_components_SvgIcon_jsx",
		"src_components_Footer_jsx-src_components_Header_jsx-node_modules_css-loader_dist_runtime_api_-5603e7",
		"src_pages_Focus_jsx"
	],
	"./Home.jsx": [
		"./src/pages/Home.jsx",
		"src_components_SvgIcon_jsx",
		"src_styles_main_scss",
		"src_components_Button_jsx",
		"src_pages_Home_jsx-node_modules_css-loader_dist_runtime_api_js-node_modules_css-loader_dist_r-c81623"
	],
	"./Qibla.jsx": [
		"./src/pages/Qibla.jsx",
		"src_components_SvgIcon_jsx",
		"src_components_Footer_jsx-src_components_Header_jsx-node_modules_css-loader_dist_runtime_api_-5603e7",
		"src_styles_qibla_scss-src_assets_images_qibla001_png-src_assets_images_qibla002_png-src_asset-641f16",
		"src_pages_Qibla_jsx"
	],
	"./Skyki.jsx": [
		"./src/pages/Skyki.jsx",
		"src_components_SvgIcon_jsx",
		"src_components_Footer_jsx-src_components_Header_jsx-node_modules_css-loader_dist_runtime_api_-5603e7",
		"src_styles_skyki_scss-src_assets_images_img001_png-src_assets_images_img002_png-src_assets_im-9848bf",
		"src_pages_Skyki_jsx"
	],
	"./Timez.jsx": [
		"./src/pages/Timez.jsx",
		"src_components_SvgIcon_jsx",
		"src_components_Footer_jsx-src_components_Header_jsx-node_modules_css-loader_dist_runtime_api_-5603e7",
		"src_styles_timez_scss-src_assets_images_timez001_png-src_assets_images_timez002_png-src_asset-13183e",
		"src_pages_Timez_jsx"
	],
	"./Todo.jsx": [
		"./src/pages/Todo.jsx",
		"src_components_SvgIcon_jsx",
		"src_components_Footer_jsx-src_components_Header_jsx-node_modules_css-loader_dist_runtime_api_-5603e7",
		"src_styles_todo_scss-src_assets_images_todoz001_png-src_assets_images_todoz002_png-src_assets-a6f61b",
		"src_pages_Todo_jsx"
	],
	"./UudData.jsx": [
		"./src/pages/UudData.jsx",
		"vendors-node_modules_css-loader_dist_runtime_api_js-node_modules_css-loader_dist_runtime_sour-cc0fa5",
		"src_components_SvgIcon_jsx",
		"src_styles_main_scss",
		"src_components_Tooltip_jsx-src_utils_adminAuth_js-src_assets_flags_sync_svg_",
		"src_pages_UudData_jsx"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = "./src/pages lazy recursive ^\\.\\/.*\\.jsx$";
module.exports = webpackAsyncContext;